import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import { Router } from 'react-router-dom';
import style from './App.module.scss';
import { history } from './history';
import AppRoutes from './routes';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
// ...

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';


function App() {
  const theme = createMuiTheme({
    typography: {
      fontFamily: ['Work Sans', 'sans-serif'].join(','),
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Router history={history}>
          <div className={style.App}>
            <AppRoutes />
          </div>
        </Router>
      </Provider>
    </ThemeProvider>
  );
}
export default App;
